<template>
  <div class="code-input-container">
    <div class="code-box" v-for="(char, index) in codeArray" :key="index">
      <div
        class="code-field code-field"
        :class="{ active: index <= currentFocusIndex, 'code-field2': isError }"
        @click="handleCode"
      >
        {{ char }}
        <div v-if="index == currentFocusIndex" class="cursor"></div>
      </div>
    </div>
    <div class="code-line"></div>
    <input
      ref="inputField"
      class="hidden-input"
      :value="codeValue"
      maxlength="6"
      type="tel"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @compositionstart="handleCompositionStart"
      @compositionend="handleCompositionEnd"
      focus
      autofocus
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentFocusIndex: 0,
      isComposing: false, // 新增组合输入状态标记
    }
  },
  props: {
    codeValue: {
      type: [String, Number],
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    codeArray() {
      return (this.codeValue + '      ').slice(0, 6).split('')
    },
  },
  watch: {
    codeValue(newVal) {
      // 确保值始终是数字字符串
      const cleaned = newVal.toString().replace(/\D/g, '')
      if (cleaned !== newVal) {
        this.$nextTick(() => {
          this.$emit('updateValue', cleaned)
        })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputField.focus()
    })
    this.currentFocusIndex = this.codeValue.length
  },
  methods: {
    handleCompositionStart() {
      this.isComposing = true
    },
    handleCompositionEnd(e) {
      this.isComposing = false
      this.handleInput(e) // 组合结束时手动触发处理
    },
    handleInput(event) {
      if (this.isComposing) return // 组合输入过程中不处理
      let value = event.target.value
        .toString()
        .replace(/\D/g, '') // 过滤非数字
        .slice(0, 6) // 确保不超过最大长度
      // 手动同步输入框值
      this.$refs.inputField.value = value
      this.currentFocusIndex = value.length
      this.$emit('updateValue', value)
      // 安卓键盘兼容性处理
      this.$nextTick(() => {
        const diff = value.length - this.codeValue.length
        if (diff > 0) {
          event.target.setSelectionRange(value.length, value.length)
        }
      })
    },
    handleBlur() {
      // 处理失去焦点逻辑
    },
    handleFocus() {
      // 处理获得焦点逻辑
    },
    // 子组件方法（正确）
    reset() {
      this.$emit('updateValue', '')
      this.currentFocusIndex = 0
      this.handleCode()
    },
    handleCode() {
      setTimeout(() => {
        this.$refs.inputField.focus()
      }, 1000)
    },
  },
}
</script>
<style scoped lang="scss">
.code-input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  overflow: hidden;
  position: relative;
}

.code-line {
  width: 10px;
  height: 2px;
  background: #2c2c2c;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hidden-input {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  //下面隐藏光标无效，曲线救国
  height: 1000px;
  opacity: 0;
  color: transparent;
  background-color: transparent;
  caret-color: transparent !important;
  /* 隐藏光标 */
  cursor: none !important;
  /* 隐藏输入光标 */
  /* 禁用缩放 */
  // transform: scale(0);
  // font-size: 16px; // 确保不会触发浏览器自动缩放
}

.code-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  // margin-right: 10px;

  &:nth-child(3) {
    margin-right: 20px !important;
  }

  // &:nth-child(6) {
  //   margin-right: 0 !important;
  // }

  .code-field {
    width: 46px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid #e1e1e1;
    font-weight: 400;
    font-size: 22px;
    color: #2c2c2c;
    line-height: 48px;
    text-align: center;
    box-sizing: border-box;
    outline: none;
  }
  .code-field2 {
    background: #ffece8 !important;
    border: 1px solid #f53f3f !important;
    color: #f53f3f !important;
  }
  .active {
    border: 1px solid #f67942;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cursor {
    width: 1px;
    height: 19px;
    background-color: #f67942;
    animation: blink 1s infinite;
  }

  /* 定义光标闪烁的动画 */
  @keyframes blink {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>
